<template>
  <AppDialog
    :show="showDialog"
    append-to-body
    size="large"
  >
    <div class="d-flex align-items-center widget-title">
      <span class="title-label mr-15">Contributors</span>
      <AppSwitch
        :value="showMetrics"
        class="title-switch leaderboard-metrics mr-5 cursor-pointer"
        label="Trend data"
        text-position="right"
        @change="(value) => $emit('toggleMetrics', value)"
      />
      <i
        v-tooltip="tooltipOptions"
        class="hi hi-info-filled hi-12 a-tooltip leaderboard-metrics"
        title="Trend data is calculated using the selected time frame until the present date against the same period of the previous time frame."
      ></i>
      <button
        class="close ml-auto flex"
        type="button"
        data-dismiss="modal"
        aria-hidden="true"
        @click="toggleDialog"
      >
        <i class="hi hi-close hi-12"></i>
      </button>
    </div>
    <AppInfiniteScroll
      ref="scroller"
      max-height="60vh"
      @loadmore="loadMoreData"
    >
      <InsightsGitHubIntegrationContributorsTable
        :table-data="tableData"
        :loading="loading"
        :lazy-loading="lazyLoading"
        :sort-options="sortOptions"
        :show-metrics="showMetrics"
        @sort="sort"
      />
    </AppInfiniteScroll>
  </AppDialog>
</template>

<script>
import InsightsGitHubIntegrationContributorsTable from '~/components/insights/InsightsGitHubIntegrationContributorsTable.vue';

export default {
  name: 'InsightsGitHubIntegrationContributorsDialog',
  components: {
    InsightsGitHubIntegrationContributorsTable,
  },
  props: {
    tableData: {
      type: Array,
      required: true,
    },
    showDialog: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    lazyLoading: {
      type: Boolean,
      required: true,
    },
    sortOptions: {
      type: Object,
      required: true,
    },
    showMetrics: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      tooltipOptions: Object.freeze({
        placement: 'right',
      }),
    };
  },
  methods: {
    loadMoreData() {
      this.$emit('loadMoreData');
    },
    sort(options) {
      this.$emit('sort', options);
    },
    toggleDialog() {
      this.$emit('closeDialog');
    },
    scrollToTop() {
      this.$refs.scroller.$el.scrollTo(0, 0);
    },
  },
};
</script>
